<div class="main-content">
  @if (instance$ | async; as instance) {
  <ng-container>
    <h1 mat-dialog-title>Poste: {{ instance?.Poste }}</h1>

    <form [formGroup]="instanceForm">
      <mat-tab-group>
        <mat-tab label="Poste">
          <table
            class="cim-full-width"
            cellspacing="0"
            style="margin-top: 10px"
          >
            <tr>
              <td>
                <mat-form-field class="cim-full-width">
                  <mat-label>Centre</mat-label>
                  <input
                    matInput
                    type="text"
                    placeholder="Centre"
                    formControlName="Centre"
                  />
                </mat-form-field>
              </td>
              <td>
                <mat-form-field class="cim-full-width">
                  <mat-label>Poste</mat-label>
                  <input
                    matInput
                    type="text"
                    placeholder="Poste"
                    formControlName="Poste"
                  />
                </mat-form-field>
              </td>
              <td>
                <mat-form-field class="cim-full-width">
                  <mat-label>Capacité Poste</mat-label>
                  <input
                    matInput
                    type="text"
                    placeholder="Capacité Poste"
                    formControlName="CapacitePoste"
                  />
                </mat-form-field>
              </td>
              <td width="25%">
                <mat-form-field class="cim-full-width">
                  <mat-label>Période</mat-label>
                  <input
                    matInput
                    type="text"
                    placeholder="Période"
                    formControlName="Periode"
                  />
                </mat-form-field>
              </td>
            </tr>
          </table>

          <div width="100%">
            <mat-form-field class="cim-full-width" >
              <mat-label>Description</mat-label>
              <input
                matInput
                type="text"
                placeholder="Description"
                formControlName="Description"
              />
            </mat-form-field>
          </div>

          @if (planningDataSource.length > 0) {
          <p>Liste des périodes</p>
          <table mat-table [dataSource]="planningDataSource">
            <ng-container matColumnDef="DateDebut">
              <th mat-header-cell *matHeaderCellDef>Date Début</th>
              <td mat-cell *matCellDef="let element">
                {{ diplayDate(element.DateDebut) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="DateFin">
              <th mat-header-cell *matHeaderCellDef>DateFin</th>
              <td mat-cell *matCellDef="let element">
                {{ diplayDate(element.DateFin) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="Indispo">
              <th mat-header-cell *matHeaderCellDef>Indisponible</th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox [checked]="element.Indispo" [disabled]="true">
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="Bloquee">
              <th mat-header-cell *matHeaderCellDef>Bloquée</th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox [checked]="element.Bloque" [disabled]="true">
                </mat-checkbox>
              </td>
            </ng-container>
            <ng-container matColumnDef="Ouverte">
              <th mat-header-cell *matHeaderCellDef>Ouverte</th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox [checked]="element.Ouverte" [disabled]="true">
                </mat-checkbox>
              </td>
            </ng-container>
            <ng-container matColumnDef="NombreUser1">
              <th mat-header-cell *matHeaderCellDef>Nombre User 1</th>
              <td mat-cell *matCellDef="let element">
                {{ element.NombreUser1 }}
              </td>
            </ng-container>
            <ng-container matColumnDef="NombreUser2">
              <th mat-header-cell *matHeaderCellDef>Nombre User 2</th>
              <td mat-cell *matCellDef="let element">
                {{ element.NombreUser2 }}
              </td>
            </ng-container>
            <ng-container matColumnDef="NombreUser3">
              <th mat-header-cell *matHeaderCellDef>Nombre User 3</th>
              <td mat-cell *matCellDef="let element">
                {{ element.NombreUser3 }}
              </td>
            </ng-container>
            <ng-container matColumnDef="Commentaire">
              <th mat-header-cell *matHeaderCellDef>Commentaire</th>
              <td mat-cell *matCellDef="let element">
                {{ element.Commentaire }}
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>

          }
        </mat-tab>
        <mat-tab label="Période du poste">
          <table mat-table [dataSource]="planningPeriodeDetail">
            <ng-container matColumnDef="JourDebut">
              <th mat-header-cell *matHeaderCellDef>Jour Début</th>
              <td mat-cell *matCellDef="let element">
                {{ displayWeekDay(element.JourDebut) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="HeureDebut">
              <th mat-header-cell *matHeaderCellDef>Heure Début</th>
              <td mat-cell *matCellDef="let element">
                {{ displayTime(element.HeureDebut) }}
              </td>
            </ng-container>
            <ng-container matColumnDef="JourFin">
              <th mat-header-cell *matHeaderCellDef>Jour Fin</th>
              <td mat-cell *matCellDef="let element">
                {{ displayWeekDay(element.JourFin) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="HeureFin">
              <th mat-header-cell *matHeaderCellDef>Heure Fin</th>
              <td mat-cell *matCellDef="let element">
                {{ displayTime(element.HeureFin) }}
              </td>
            </ng-container>
            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumnsPeriode; sticky: true"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumnsPeriode"
            ></tr>
          </table>
        </mat-tab>
      </mat-tab-group>

      <div mat-dialog-actions>
        <button
          mat-raised-button
          [mat-dialog-close]="true"
          cdkFocusInitial
          class="mat-raised-button mat-primary"
        >
          Ok
        </button>
      </div>
    </form> </ng-container
  >}
</div>
